import React, { useCallback } from 'react';
import SearchPicker, { PickerOption } from '../pettyCash/SearchPicker';
import e2iApi from '../../services/e2iApi';
import type { PartyRef } from '../../types/e2i';

interface Props {
  id: string;
  companyId: number;
  label?: string;
  value: PartyRef | null;
  onChange: (value: PartyRef | null) => void;
  required?: boolean;
  disabled?: boolean;
  helperText?: React.ReactNode;
}

/** An SAP project of the company, searched by code or name (read live from SAP). */
const ProjectSearchPicker: React.FC<Props> = ({ id, companyId, label = 'Project (main job)', value, onChange, required, disabled, helperText }) => {
  const search = useCallback(async (q: string): Promise<PickerOption[]> => {
    const rows = await e2iApi.projects(companyId, q);
    return rows.map((r) => ({
      code: r.code,
      name: r.name,
      hint: [r.type, r.parent ? `under ${r.parent}` : ''].filter(Boolean).join(' · ') || undefined,
    }));
  }, [companyId]);

  return (
    <SearchPicker
      id={id}
      label={label}
      value={value ? { code: value.code, name: value.name } : null}
      onChange={(o) => onChange(o ? { code: o.code, name: o.name } : null)}
      search={search}
      required={required}
      disabled={disabled}
      helperText={helperText}
      placeholder="Code or name"
    />
  );
};

export default ProjectSearchPicker;
